import React, { useState, useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { AuthContext } from '../../../services/auth/AuthProvider';
import { GET_REWARD_CARD_PACK_BY_ID, GET_REWARD_CARDS_BY_ID } from '../services/graphql';

import { Loader } from '@squirrellearningltd/go-pupil-components';
import CardHolder from '../components/CardHolder';
import styles from './RewardsCards.module.scss';

const RewardCards = ({ packId, selectedPackData, setSelectedPackToParent }) => {
    const { currentUser } = useContext(AuthContext);

    const [selectedPack, setSelectedPack] = useState(selectedPackData);
    const [packCards, setPackCards] = useState();

    const { error, loading } = useQuery(GET_REWARD_CARDS_BY_ID, {
        variables: {
            rewardCardPackId: packId
        },
        onCompleted: data => {
            setPackCards(data.rewardCardsById);
        }
    });

    const { data: rewardCardPackData } = useQuery(GET_REWARD_CARD_PACK_BY_ID, {
        variables: {
            rewardCardPackId: packId
        },
        skip: selectedPackData,
        onCompleted: (data) => {
            if (data?.rewardCardPackById) {
                setSelectedPack(data.rewardCardPackById)
                setSelectedPackToParent(data.rewardCardPackById)
            }
        }
    });


    if (loading) {
        return <p>Loading...</p>
    }

    if (error) {
        return <p>{error.message}</p>
    }

    if (packCards) {
        const canBuyWinner = currentUser.studentRewardCards.filter(c => c.rewardCard.pack === selectedPack?.pack).length === packCards.filter(c => !c.chapterWinnerOnly).length;

        return (
            <div className={styles.rewards}>
                <div className='card'>
                    <div className='card-body'>
                        <div className={styles.rewardsWrapper}>
                            {loading ? <Loader /> :
                                !!packCards.length && packCards.map((card, i) => {
                                    return (
                                        <CardHolder
                                            key={`'card-${card.id}`}
                                            userCard={currentUser.studentRewardCards.find(c => c.rewardCard.id === card.id)}
                                            card={card}
                                            i={i}
                                            selectedPack={selectedPack}
                                            canBuyWinner={canBuyWinner}
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return null
}

export default RewardCards;